import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import mlHelper from '../../../helpers/ml.helper';
import PostsCategories from './PostsCategories';
import columnTypes from '../../../components/cms/grid/columnTypes';
import ModelService from '../../../services/postCategory.service';
import PreviewImage from '../../../components/previewImage';
import gc from '../../../components/cms/gridComponents';

const getColumns = (pageList, t) => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color="secondary">
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypeOptions(t)),
  },
  {
    name: 'title',
    title: t('Title'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'image',
    title: '',
    value: ({ item }) => (
      <div className="center">
        <Link to={ModelService.getUpdateUrl(item.id)}>
          <PreviewImage height="35" src={ModelService.getImage(item.image, 100, 100)} alt={item.name} />
        </Link>
      </div>
    ),
    filter: false,
    sort: false,
  },
  {
    name: 'status',
    title: t('Status'),
    value: gc.checkBoxDataCell({ ModelService, t, attr: 'status' }),
    filter: gc.checkBoxFilter({ ModelService, t }),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  mlHelper.core,
  defaultProps({
    getColumns,
  }),
);

export default hoistStatics(enhance)(PostsCategories);



// WEBPACK FOOTER //
// ./src/views/blog/postsCategories/index.js